import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Signin } from "../redux/slices/auth";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const checkstate = useSelector((v) => v.login.loading);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      await dispatch(Signin(data, navigate));
    } catch (err) {
      console.error("Error during login:", err);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-100 to-gray-300 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-2xl transition-all duration-300 hover:scale-[1.01]">
        <div className="text-center">
          <img
            className="mx-auto h-32 w-auto"
            src="/images/logo.png"
            alt="Your Company"
          />
          <h2 className="mt-6 text-2xl font-bold text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          {/* Email Field */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Email address
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              className="mt-1 w-full placeholder-gray-500  rounded-md border border-gray-300 px-3 py-2 text-gray-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              {...register("email", { required: "Email is required" })}
              placeholder="Enter your email..."
            />
            <div className="min-h-[20px] mt-1">
              {errors.email && (
                <p className="text-sm text-red-600">{errors.email.message}</p>
              )}
            </div>
          </div>

          {/* Password Field with Eye Icon */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <div className="relative mt-1 min-h-[48px]">
              <input
                id="password"
                // type={showPassword ? "text" : "password"}
                type="password"
                autoComplete="current-password"
                className="w-full rounded-md placeholder-gray-400 border border-gray-300 px-3 py-2 pr-10 text-gray-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                {...register("password", { required: "Password is required" })}
                placeholder="Enter your password..."
              />
              {/* <button
                type="button"
                className="absolute inset-y-0 right-2 flex items-center"
                onClick={handleClickShowPassword}
                tabIndex={-1}
              >
                {showPassword ? (
                  <VisibilityOff className="text-gray-500" />
                ) : (
                  <Visibility className="text-gray-500" />
                )}
              </button> */}
            </div>
            <div className="min-h-[20px] mt-1">
              {errors.password && (
                <p className="text-sm text-red-600">
                  {errors.password.message}
                </p>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-indigo-700 px-4 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={checkstate}
            >
              {checkstate ? (
                <div className="flex items-center gap-2">
                  <span>Loading...</span>
                  <svg
                    className="h-5 w-5 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 
                      5.291A7.962 7.962 0 014 12H0c0 3.042 
                      1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                </div>
              ) : (
                "Login"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
